export default __webpack_public_path__ + "static/media/021-Leaning Tower of Pisa.b916c17d.svg";